import React, { useEffect, useRef } from 'react';
import Spinner from './Spinner';
import Alert from './Alert';

export default function ConfirmDeleteModal(props) {
  const cancelRef = useRef(null);
  const busy = props.busy;

  // Read through a ref so the Escape listener is bound once.
  const latest = useRef(props);
  latest.current = props;

  // Focus the safe choice, not the destructive one.
  useEffect(function () {
    if (cancelRef.current) cancelRef.current.focus();
  }, []);

  useEffect(function () {
    function onKeyDown(event) {
      if (event.key === 'Escape' && !latest.current.busy) {
        latest.current.onCancel();
      }
    }
    document.addEventListener('keydown', onKeyDown);
    document.body.classList.add('is-modal-open');

    return function () {
      document.removeEventListener('keydown', onKeyDown);
      document.body.classList.remove('is-modal-open');
    };
  }, []);

  return (
    <div
      className="modal-backdrop"
      onMouseDown={function (event) {
        if (event.target === event.currentTarget && !busy) props.onCancel();
      }}
    >
      <div
        className="modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="confirm-title"
        aria-describedby="confirm-description"
      >
        <h2 className="modal__title" id="confirm-title">
          Delete your account?
        </h2>

        <div className="modal__body" id="confirm-description">
          <p>
            This permanently deletes your account and all personal data
            associated with it &mdash; your profile, photo, contact details,
            visit history and points.
          </p>
          <p className="modal__emphasis">
            This cannot be undone, and your points cannot be restored.
          </p>
        </div>

        {props.error ? <Alert tone="error">{props.error}</Alert> : null}

        <div className="modal__actions">
          <button
            ref={cancelRef}
            type="button"
            className="button button--ghost"
            onClick={props.onCancel}
            disabled={busy}
          >
            No, keep my account
          </button>
          <button
            type="button"
            className="button button--danger"
            onClick={props.onConfirm}
            disabled={busy}
          >
            {busy ? <Spinner light /> : null}
            {busy ? 'Deleting\u2026' : 'Yes, delete my account'}
          </button>
        </div>
      </div>
    </div>
  );
}
